import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';
import { Cow, FertilitySummary } from '../models/fertility.model';

@Injectable({
  providedIn: 'root',
})
export class FertilityReportService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/herd/secure/report/fertility';

  getCows(date: string): Observable<Cow[]> {
    return this.http.get<Cow[]>(`${this.baseUrl}/cows?date=${date}`);
  }

  getSummary(date: string): Observable<FertilitySummary> {
    return this.http.get<FertilitySummary>(`${this.baseUrl}/summary?date=${date}`);
  }
}
